import { createAsyncThunk } from '@reduxjs/toolkit';
import { TimeZoneClient } from '../../../api/api';
import { AsyncOperationHandler } from '../../../utilities/platform-helpers/api-helper';
import { timeZoneClient } from '../../api-clients';

export const getTimeZones = createAsyncThunk('timezone/getTimeZones', () => {
  return AsyncOperationHandler((client) => (client as TimeZoneClient).get(), timeZoneClient);
});
